import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const HERO_IMG = "https://customer-assets-lxgj4vgw.emergentagent.net/job_6dc3909f-878c-4eee-8cfe-c2f27fad2cc4/artifacts/8b2b8b2e4b29f4b1_476A5881-FC18-4BA4-A5D4-CC2AAA963F91.png";

const sideWords = ["PEOPLE", "IDEAS", "INSTITUTIONS", "OPPORTUNITIES", "A MORE", "ADAPTIVE", "TOMORROW"];

const Hero = () => {
  return (
    <section className="relative w-full min-h-screen lg:min-h-0 lg:aspect-video flex items-center overflow-hidden pt-20" data-testid="hero-section">
      <motion.div
        initial={{ opacity: 0, scale: 1.04 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1.2 }}
        className="absolute inset-0"
      >
        <img
          src={HERO_IMG}
          alt="Raulvin Coke — Futurist, Founder, Speaker"
          className="w-full h-full object-cover"
          style={{ objectPosition: "28% center", transform: "scaleX(-1)" }}
          data-testid="hero-image"
        />
      </motion.div>
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute inset-y-0 left-0 w-full lg:w-[62%] bg-gradient-to-r from-[var(--bg-primary)] via-[var(--bg-primary)]/80 to-transparent" />
        <div className="absolute inset-0 bg-[var(--bg-primary)]/40 lg:hidden" />
        <div className="absolute bottom-0 left-0 w-full h-40 bg-gradient-to-t from-[var(--bg-primary)] to-transparent" />
        <div className="absolute top-0 left-0 w-full h-32 bg-gradient-to-b from-[var(--bg-primary)]/70 to-transparent" />
      </div>

      <div className="absolute top-1/4 right-6 md:right-10 z-20 space-y-2.5 hidden md:block" data-testid="hero-side-words">
        {sideWords.map((word, i) => (
          <motion.span
            key={word}
            initial={{ opacity: 0, x: 15 }}
            animate={{ opacity: 0.6, x: 0 }}
            transition={{ delay: 0.9 + i * 0.08, duration: 0.4 }}
            className="block text-right text-[10px] md:text-xs tracking-[0.25em] text-white/70 uppercase font-medium"
          >
            {word}
          </motion.span>
        ))}
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-8 w-full">
        <div className="max-w-xl">
          <div className="space-y-6">
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="text-xs uppercase tracking-[0.35em] text-[var(--accent-violet-light)] font-semibold"
            >
              The People's Futurist
            </motion.p>

            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.1 }}
              className="font-display text-6xl sm:text-7xl lg:text-8xl xl:text-[6.5rem] font-bold leading-[0.9] text-white"
              data-testid="hero-heading"
            >
              Raulvin<br />Coke
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.25 }}
              className="font-display text-lg md:text-xl text-[var(--accent-violet-light)] italic max-w-md"
            >
              AI, Adaptive Intelligence &amp;<br />
              the Future of Human Decision-Making
            </motion.p>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.35 }}
              className="text-sm md:text-base text-[var(--text-secondary)] leading-relaxed max-w-md"
            >
              Tracking the forces reshaping work, education, skills, economic mobility, and human opportunity — then translating them into decisions leaders can act on.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.45 }}
              className="flex flex-wrap gap-3 pt-2"
            >
              <Link
                to="/intelligence"
                className="group bg-[var(--accent-violet)] hover:bg-[#6d28d9] text-white px-6 py-3 rounded-full font-semibold text-sm transition-all flex items-center gap-2 shadow-lg shadow-violet-900/30"
                data-testid="hero-signals-btn"
              >
                Explore Future Signals
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </Link>
              <Link
                to="/speaking"
                className="border border-[rgba(124,58,237,0.4)] hover:border-[var(--accent-violet)] hover:bg-[rgba(124,58,237,0.08)] text-white px-6 py-3 rounded-full font-medium text-sm transition-all"
                data-testid="hero-speak-btn"
              >
                Invite Raulvin to Speak
              </Link>
            </motion.div>

            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.6 }}
              className="text-xs text-[var(--text-secondary)]/70 pt-4"
            >
              Founder &amp; CEO, Agentic FuturePath AI &nbsp;|&nbsp; Futurist &nbsp;|&nbsp; Speaker &nbsp;|&nbsp; Advisor
            </motion.p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Hero;
